export default __webpack_public_path__ + "9d4e3d108f909faa0cfe86d2ed4e4aa1.png";